import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FullScreenBackground } from "../../compoment/PortraitStage";
import mainBg from "../../assets/img/mainBG.png";
import Loader from "../../compoment/ui/Loader";
import { resolveNextCategoryInSequence } from "../../api";
import { toast } from "react-toastify";
import { useRouteFrozen } from "../../routes/routeTransition";

/**
 * Category selection is hidden. This route only resolves the next category
 * in sequence and forwards the user to /main.
 */
const CategoryScreen = () => {
    const navigate = useNavigate();
    const routeFrozen = useRouteFrozen();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (routeFrozen) return undefined;
        let cancelled = false;

        const forwardToNextCategory = async () => {
            try {
                const nextCategory = await resolveNextCategoryInSequence();
                if (cancelled) return;

                if (!nextCategory) {
                    toast.error("Unable to assign a category. Please try again.");
                    navigate("/qr-scan", { replace: true });
                    return;
                }

                navigate("/main", {
                    replace: true,
                    state: {
                        category: nextCategory.name,
                        categoryObject: nextCategory,
                    },
                });
            } catch (error) {
                console.error("Failed to resolve next category:", error);
                if (!cancelled) {
                    toast.error("Unable to assign a category. Please try again.");
                    navigate("/qr-scan", { replace: true });
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        forwardToNextCategory();
        return () => {
            cancelled = true;
        };
    }, [navigate, routeFrozen]);

    return (
        <>
            {loading && <Loader />}
            <FullScreenBackground image={mainBg} />
        </>
    );
};

export default CategoryScreen;
